export default __webpack_public_path__ + "static/media/user_placeholder.983c6da0.svg";